import { render } from "./ButtonUserDropdown.vue?vue&type=template&id=fee6e1d2&scoped=true"
import script from "./ButtonUserDropdown.vue?vue&type=script&lang=js"
export * from "./ButtonUserDropdown.vue?vue&type=script&lang=js"

import "./ButtonUserDropdown.vue?vue&type=style&index=0&id=fee6e1d2&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-fee6e1d2"

export default script